import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconApplePodcasts$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconApplePodcasts extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '88c4f50cce1cb0d53ab4e1635f692273c3b2476d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bbe8e4c2a5c08816be224dd95c87ec29e218c243', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd37378631d33cfbfd3a69cc8731d4d667f05f785', d: "M12.523 12.599c-.31-.328-.856-.538-1.5-.538-.643 0-1.188.21-1.499.537a.95.95 0 0 0-.274.596c-.053.484-.023.9.033 1.565.054.634.157 1.48.29 2.34.095.614.173.945.243 1.181.114.384.54.72 1.208.72s1.093-.336 1.207-.72c.07-.236.148-.567.243-1.18.134-.861.236-1.707.29-2.34.057-.666.086-1.082.034-1.566a.95.95 0 0 0-.275-.596m-3.19-2.917a1.693 1.693 0 1 0 3.385 0 1.693 1.693 0 0 0-3.386 0M11.003 3c-3.96.011-7.204 3.224-7.253 7.184-.04 3.207 2.007 5.95 4.867 6.957a.097.097 0 0 0 .128-.106 42 42 0 0 1-.105-.746.25.25 0 0 0-.147-.197 6.35 6.35 0 0 1-3.813-5.879c.034-3.445 2.847-6.254 6.292-6.282a6.35 6.35 0 0 1 6.397 6.344 6.35 6.35 0 0 1-3.814 5.817.25.25 0 0 0-.146.198q-.05.37-.106.745c-.01.072.06.13.13.106 2.831-.996 4.867-3.698 4.867-6.866 0-4.018-3.276-7.286-7.297-7.275m-.131 3.338a3.947 3.947 0 0 1 4.098 3.94c0 1.131-.48 2.153-1.246 2.873a.3.3 0 0 0-.095.237c.016.27.01.534-.008.83-.005.08.084.13.15.086a4.87 4.87 0 0 0 2.13-4.027 4.88 4.88 0 0 0-5.066-4.87 4.89 4.89 0 0 0-4.68 4.807 4.87 4.87 0 0 0 2.13 4.09.096.096 0 0 0 .15-.085 7 7 0 0 1-.01-.831.3.3 0 0 0-.094-.237 3.93 3.93 0 0 1-1.245-2.98 3.954 3.954 0 0 1 3.786-3.833", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-apple-podcasts", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-apple-podcasts"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-apple-podcasts":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconApplePodcasts$1);
            }
            break;
    } });
}

const CosmosIconApplePodcasts = CosmosIconApplePodcasts$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconApplePodcasts, defineCustomElement };
